{
  "actionbar.actions": "Действия",
  "actionbar.actionsAvailable": "Действия доступны.",
  "actionbar.clearSelection": "Очистить выбор",
  "actionbar.selected": "{count, plural, =0 {Не выбрано} other {Выбрано #}}",
  "actionbar.selectedAll": "Выбрано все",
  "actionbutton.pending": "в ожидании",
  "breadcrumbs.more": "Дополнительные элементы",
  "button.pending": "в ожидании",
  "calendar.invalidSelection": "{selectedCount, plural, one {Выбранная дата недоступна} other {Выбранные даты недоступны}}.",
  "combobox.loading": "Загрузка...",
  "combobox.loadingMore": "Дополнительная загрузка...",
  "combobox.noResults": "Результаты отсутствуют",
  "contextualhelp.help": "Справка",
  "contextualhelp.info": "Информация",
  "datepicker.endTime": "Время окончания",
  "datepicker.startTime": "Время начала",
  "datepicker.time": "Время",
  "dialog.alert": "Предупреждение",
  "dialog.dismiss": "Пропустить",
  "dropzone.replaceMessage": "Перетащите файл для замены",
  "inlinealert.informative": "Информация",
  "inlinealert.negative": "Ошибка",
  "inlinealert.notice": "Предупреждение",
  "inlinealert.positive": "Успешно",
  "label.(optional)": "(дополнительно)",
  "label.(required)": "(обязательно)",
  "listview.loading": "Загрузка...",
  "listview.loadingMore": "Дополнительная загрузка...",
  "menu.loading": "Загрузка...",
  "menu.loadingMore": "Дополнительная загрузка...",
  "menu.moreActions": "Дополнительные действия",
  "menu.noResults": "Результаты отсутствуют",
  "menu.unavailable": "Недоступно, разверните для подробностей",
  "notificationbadge.indicatorOnly": "Новая активность",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "Загрузка...",
  "picker.loadingMore": "Дополнительная загрузка...",
  "picker.placeholder": "Выбрать…",
  "picker.selectedCount": "{count, plural, =0 {Нет выбранных элементов} one {# элемент выбран} other {# эл. выбрано}}",
  "sidepanel.collapse": "Свернуть боковую панель",
  "sidepanel.expand": "Развернуть боковую панель",
  "slider.maximum": "Максимум",
  "slider.minimum": "Минимум",
  "table.cancel": "Отмена",
  "table.drag": "Перетаскивание",
  "table.editCell": "Редактировать ячейку",
  "table.loading": "Загрузка...",
  "table.loadingMore": "Дополнительная загрузка...",
  "table.resizeColumn": "Изменить размер столбца",
  "table.save": "Сохранить",
  "table.sortAscending": "Сортировать по возрастанию",
  "table.sortDescending": "Сортировать по убыванию",
  "tag.actions": "Действия",
  "tag.hideButtonLabel": "Показать меньше",
  "tag.noTags": "Нет",
  "tag.showAllButtonLabel": "Показать все ({tagCount, number})",
  "toast.clearAll": "Очистить все",
  "toast.collapse": "Свернуть",
  "toast.showAll": "Показать все",
  "treeview.loadingMore": "Дополнительная загрузка..."
}
